import templateComponents from '../../../Template/theme/components'
import scorecard from './scorecard'

export default {
    ...templateComponents,
    scorecard
}


// WEBPACK FOOTER //
// ./src/app/configuration/Discover/theme/components/index.js